module.exports = __webpack_public_path__ + "media/packs/images/flags/VN-b63d627fb1e25b72ab37a856db5e03be.svg";